import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetMyPendingChallenges } from "../../api-clients/challengesClient";
import { extractInfoFromInfiniteData, extractListRecords } from "../utils";

function useGetMyPendingChallengesInfiniteQuery({
  limit,
  gameId,
  inviteId,
  sort,
  refetchInterval,
}: {
  limit?: number;
  sort?: string;
  inviteId?: string;
  gameId?: string;
  refetchInterval?: number;
} = {}) {
  const query = useInfiniteQuery({
    queryKey: [QUERY_KEYS.GAME.ALL_GAMES],
    queryFn: ({ pageParam }) =>
      handleGetMyPendingChallenges({
        page: pageParam,
        limit,
        gameId,
        sort,
        inviteId,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    refetchInterval,
  });

  const pendingChallengesList = useMemo(
    () => extractInfoFromInfiniteData(query.data),
    [query.data]
  );

  const pendingChallenges = useMemo(
    () => extractListRecords(pendingChallengesList),
    [pendingChallengesList]
  );

  return { pendingChallenges, query };
}

export default useGetMyPendingChallengesInfiniteQuery;
